import { config } from "zod";

/**
 * Zodは初回スキーマ構築時に`Function("")`でJITコンパイルの可否を自己診断する
 * （`navigator.userAgent`に`"Cloudflare"`を含まない環境では常に試みる）。
 * 本サイトのCSP（`script-src 'self'`。`unsafe-eval`なし）ではこの診断自体が
 * ブロックされ、Zod自身は例外を握りつぶし`jitless`側へ正しくフォールバックするが、
 * ブラウザは`securitypolicyviolation`を発生させる（NFR-004・計画16タスク8で発見）。
 *
 * `jitless: true`をどのZodスキーマよりも先にグローバル設定し、この診断自体を
 * 起こさせないようにする。`src/main.tsx`の最初のimportにすることで、
 * `import "zod"`を含む他のどのモジュールよりも先に実行させる。
 */
config({ jitless: true });
